<template>
    <table id="inventoryRequestTable" class="table">
        <thead>
        <tr>
            <td class="">Item Name </td>
            <td class="">Demanded Quantity</td>
            <td class="">Received Quantity</td>
            <td class="" v-if="IsSupplyChain">Approved Quantity</td>
            <td class="">Minimum Level at COPC</td>
            <td class="">Available Stock at COPC</td>
            <td class="" v-if="IsSupplyChain">Available Quantity at Warehouse</td>
            <td class="">Actions</td>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(row, index) in itemrows" :key="index" :class="{'bg-light' : row.isNew}">
            <td class="">
                <select name="ItemId[]" v-model="row.ItemId" class="form-control form-control-sm" required @change="retrieveAvailableQuantity(row.ItemId)">
                    <option v-for="(item, index) in newItems" :key="item.Id" :value="item.Id">{{ item.Name }}</option>
                </select>
            </td>
            <td class="">
                <input type="number" name="DemandedQuantity[]"  v-model="row.DemandedQuantity" class="form-control form-control-sm" required/>
            </td>
            <td class="">
                <input type="number" name="ReceivedQuantity[]"  v-model="row.ReceivedQuantity" class="form-control form-control-sm"/>
            </td>
            <td class="" v-if="IsSupplyChain">
                <input type="number" name="ApprovedQuantity[]" maxlength="3" v-model="row.ApprovedQuantity" class="form-control form-control-sm" required/>
                <!-- <input type="number" name="ApprovedQuantity[]" maxlength="3" :readonly="!row.CanApproveQuantity" v-model="row.ApprovedQuantity" class="form-control form-control-sm" required/> -->
                <!-- <ul v-if="!row.CanApproveQuantity || row.ApprovedQuantity > row.AvailableQuantity">
                    <li v-if="!row.CanApproveQuantity" style="color: red;"><span class="font-italic text-danger font-weight-700">* No available quantity</span></li>
                <li v-if="row.ApprovedQuantity > row.AvailableQuantity" style="color: red;"> <span class="font-italic text-danger font-weight-700">* Quantity limit exceeds.</span></li>
                </ul> -->

            </td>
            <td class="">
                <input type="number" name="MinimalLevelQuantity[]"  v-model="row.MinimalLevelQuantity" class="form-control form-control-sm" />
            </td>
            <td class="">
                <input type="number" name="AvailableQuantity[]"  v-model="row.AvailableQuantity" class="form-control form-control-sm" readonly/>
            </td>
            <td class="" v-if="IsSupplyChain">
                <input type="number" name="AvailableQuantityAtWarehouse[]"  v-model="row.AvailableQuantityAtWarehouse" class="form-control form-control-sm" readonly/>
            </td>
            <td class="">
                <a class="btn btn-sm btn-danger text-white" @click="removeRow(index, row)"><i class="fas fa-trash-alt"></i></a>
            </td>
        </tr>
        </tbody>
        <tfoot>
        <tr>
            <td colspan="5">
                <div class="text-right">
                <button type="button" class="btn btn-sm btn-outline-info  w-25" v-on:click="addNewItemRow()" id="addrow">
                    Add New Item
                </button>
                </div>
            </td>
        </tr>
        </tfoot>
    </table>
</template>
<script>
    export default {
        name : 'inventory-request-item-list',
        props : ['newItems', 'InventoryRequestId', 'IsSupplyChain', 'IsWarehouse'],
        data(){
            return {
                URLInventoryRequestItemPost: 'inventory-requests/items/available-quantity',
                itemrows: [
                    {
                        Id : null,
                        ItemId: null,
                        DemandedQuantity: null,
                        ReceivedQuantity: null,
                        ApprovedQuantity: null,
                        MinimalLevelQuantity: null,
                        AvailableQuantity: null,
                        AvailableQuantityAtWarehouse: null,
                        CanApproveQuantity: null,
                        isNew: null,
                    }
                ],
                submitted:false,
                URLinventoryRequestEditItemList: 'inventory-requests/items/editlist',
                URLinventoryRequestEditDeleteItem: 'inventory-requests/items/deleteItem'
            }
        },
        methods:{
            retrieveAvailableQuantity: function(itemId)
            {
                const index = this.itemrows.findIndex(project => project.ItemId == itemId);
                axios.post(this.URLInventoryRequestItemPost + '/' + this.InventoryRequestId, { "ItemId" : itemId })
                .then(response => {
                    
                    this.itemrows[index].AvailableQuantity = response.data.data;

                }).
            catch(error => {
                this.errored = true
            })
            .finally(() => this.loading = false)
            },
            addNewItemRow: function(){
                this.itemrows.push({
                    Id : null,
                        ItemId: null,
                        DemandedQuantity: null,
                        ReceivedQuantity: null,
                        ApprovedQuantity: null,
                        MinimalLevelQuantity: null,
                        AvailableQuantity: null,
                        AvailableQuantityAtWarehouse: null,
                        CanApproveQuantity: null,
                    isNew: true,
                });

                this.itemrows = this.checkUniqueItems(this.itemrows, 'ItemId')
            },
            removeRow: function(index, row){
                if(row.isNew){
                    return this.itemrows.splice(index, 1);
                }
                Swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                    if (result.isConfirmed) {
                        // getting items of posted inventory Request
                        axios.get(this.URLinventoryRequestEditDeleteItem + '/' + row.Id)
                            .then(response => {
                                console.log(response.data)
                                Swal.fire(
                                    'Deleted!',
                                    'Your item has been deleted.',
                                    'success'
                                )
                                this.itemrows.splice(index, 1);
                            }).
                catch(error => {
                    this.errored = true
                })
                .finally(() => this.loading = false)


                    }
                })

            },
            checkUniqueItems: function(arr, key){
                var uniqueItems = [...new Map(arr.map(item => [item[key], item])).values()]
                return uniqueItems;
            },
            callItemsFromApi: function(InventoryRequestId){
                // getting items of posted inventory Request
                axios.get(this.URLinventoryRequestEditItemList + '/' + InventoryRequestId)
                    .then(response => {
                        this.itemrows = response.data.data
                    }).
                catch(error => {
                    this.errored = true
                })
                    .finally(() => this.loading = false)
            }
        },
        mounted() {
            this.callItemsFromApi(this.InventoryRequestId)

        }
    }
</script>
